export const Urls = Object.freeze({
  ABOUT: '/about',
  CAREERS: 'https://careers.siriusxm.com/careers',
  ADVERTISING: 'https://www.siriusxmmedia.com/advertising-on-pandora',
  BUSINESS: 'https://cloudcovermusic.com/',
  AMP: 'https://amp.pandora.com/splash',
  INVESTOR:
    'https://investor.siriusxm.com/investor-overview/default.aspx?intcmp=GN_FOOTER_NEW_SiriusXMCorporate_InvestorRelations',
  BLOG: 'https://blog.pandora.com/',
  GIFTS: '/subscription/gift',
  PRIVACY: '/privacy',
  PRIVACY_CHOICES: '/privacy/redirect/privacychoices',
  TERMS: '/legal',
  SUBSCRIPTION_TERMS: '/legal/subscription',
  STUDENT_TERMS: '/legal/subscription/student-discount',
  MILITARY_TERMS: '/legal/subscription/military-discount',
  TRIAL_OFFERS_TERMS: '/legal/subscription-offer-terms',
  HELP: 'https://help.pandora.com',
  ADVERTISING_PREFERENCES: '/advertising/preferences',
  PREMIUM_LINK: '/premium',
  CANCEL:
    'https://help.pandora.com/s/article/Cancel-your-Subscription-1519949295562?language=en_US',
  UPGRADE: '/upgrade',
  SUBSCRIPTION: '/settings/subscription',
  DOWNLOAD_DESKTOP_APP: 'https://pandora.com/desktop',
} as const);

// t-mobile views are not supported on desktop, need to show alternate message
export const TMOBILE_PLACEHOLDER_URLS = {
  '/browse/content/t‑mobile/BR:82': true,
  '/browse/content/t%E2%80%91mobile/BR:82': true,
};

export const oldToNewBrowsePathsMap = Object.freeze({
  '/music/top-stations': '/browse/music/top-stations',
  '/music/decades': '/browse/music/decades',
} as const);

export const superBrowseToBrowseMap = Object.freeze({
  '/browse/content/new-albums/BR:40': '/browse',
  '/browse/content/featured-playlists/BR:12': '/browse/music/featured-playlists',
  '/browse/content/podcasts/BR:38': '/browse/podcasts',
  '/browse/content/top-songs/BR:49': '/browse',
  '/browse/content/top-artists/BR:13': '/browse/music/top-artists',
  '/browse/content/moods/BR:7': '/browse/music/activities',
  '/browse/content/decades/BR:6': '/browse/music/decades',
  '/browse/content/top-stations/BR:14': '/browse/music/top-stations',
  '/browse/content/trending-artists/BR:15': '/browse/music/artists-on-the-rise',
  '/browse/content/trending/BR:48': '/browse',
  '/browse/content/genres/BR:50': '/browse/music/genres',
} as const);

export const deepLinkParams = Object.freeze({
  // Channel
  MOBILE_WEB: 'Mobile Web',
  USER_SHARED: 'User Shared',
  DESKTOP_APP: 'Desktop App',
  // Feature
  HOMEPAGE: 'Homepage',
  HAMBURGER_MENU: 'Hamburger Menu',
  BACKSTAGE_PAGE: 'Backstage Page',
  NOW_PLAYING: 'Now Playing',
  COLLECTION: 'My Collection',
  BROWSE: 'Browse',
  SEARCH: 'Search',
  REGISTRATION_WELCOME: 'Registration Welcome',
  LOG_IN_WELCOME: 'Log In Welcome',
  GENERIC_PARTNER_WELCOME: 'Generic Partner Welcome',
  GENERIC_PARTNER_FAMILY_WELCOME: 'Generic Partner Welcome T3F',
  PAYMENT_SUCCESS: 'Payment Success',
  PREMIUM_ALREADY_SUBSCRIBED: 'Premium Already Subscribed',
  PLUS_ALREADY_SUBSCRIBED: 'Plus Already Subscribed',
  // Tier
  AD_SUPPORTED: 'T1',
  PANDORA_PLUS: 'T2',
  PANDORA_PREMIUM: 'T3',
  PREMIUM_FAMILY_PLAN: 'T3',
  // Platform
  DESKTOP: 'Desktop',
} as const);
